import { render, staticRenderFns } from "./MediaImg.vue?vue&type=template&id=1cb50bd6&scoped=true&"
import script from "./MediaImg.vue?vue&type=script&lang=ts&"
export * from "./MediaImg.vue?vue&type=script&lang=ts&"
import style0 from "./MediaImg.vue?vue&type=style&index=0&id=1cb50bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb50bd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VImg,VSkeletonLoader})
